import $ from 'jquery';
import 'slick-carousel';
import SlickPlayPauseControls from './Slick.PlayPauseControls';
import BackgroundImage from './BackgroundImage';

const defaults = {
  fade: true,
  speed: 1000,
  arrows: false,
  dots: false,
  autoplay: true,
  pauseOnHover: false,
  autoplaySpeed: 5000,
  infinite: true,
  cssEase: 'cubic-bezier(0.165,0.84,0.44,1)',
  waitForAnimate: false,
  responsive: [{
    breakpoint: 1200,
    settings: {
      speed: 500,
      autoplay: false,
    },
  }],
};

/**
 * Gallery Constructor
 */
function Hero(element, options) {
  this.element = element;
  this.$element = $(element);
  this.settings = $.extend(true, defaults, options);
  this.addBackgrounds = this.addBackgrounds.bind(this);

  // add slick carousel functionality
  this.$slickContainer = this.addSlick();

  // add play/pause functionality
  this.controls = this.addControls();

  // set component ready
  this.ready();
}

Hero.prototype = {
  addSlick() {
    const $slider = this.$element.find('.view-content');
    $slider.on('init breakpoint', this.addBackgrounds);
    return $slider
      .slick(this.settings);
  },
  addControls() {
    return new SlickPlayPauseControls(this.$slickContainer, {
      attachTo: this.$slickContainer,
    });
  },
  addBackgrounds() {
    $('.slick-slide', this.element).each((i, element) => {
      element.backgroundImage = new BackgroundImage(element, {
        destSelector: undefined,
        sourceSelector: '.node-content .field-image.c1 img',
      });
    });
  },
  ready() {
    this.$element.closest('.page-top').addClass('ready');
  },
};

export default Hero;
